import { Plugin } from "..";

const id = "image-viewer";

export const ImageViewer: Plugin = {
	id,
	type: "event",
	header: {
		visible: false,
		edit: false,
		fullscreen: true,
	},
	name: "imageViewer",
	component: defineAsyncComponent(() => import("./ImageViewerPlugin.vue")),
	config: defineAsyncComponent(() => import("./ImageViewerPluginConfig.vue")),
	dataConfig: null,
	defaultDataResolver: () => undefined,
	defaultOptionsResolver: () => undefined,
	dimension: {
		minHeight: 4,
		minWidth: 4,
	},

	currentVersion: 1,
	migrations: {},
};
